import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

Vue.use(Router);
Vue.use(Meta);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      redirect: { name: "dashboard" },
    },
    {
      path: "/:organizer(\\d+)",
      component: require("./views/EmptyRouterView.vue").default,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          component: require("./views/Wrapper.vue").default,
          children: [
            {
              path: "",
              redirect: { name: "dashboard" },
            },
            {
              path: "dashboard",
              component: require("./views/Dashboard.vue").default,
              name: "dashboard",
            },
            {
              path: "events",
              component: require("./views/events/Index.vue").default,
              name: "events",
            },
            {
              path: "events/create",
              component: require("./views/events/Create.vue").default,
              name: "events.create",
            },
            {
              path: "orders",
              component: require("./views/orders/Index.vue").default,
              name: "orders",
            },
            {
              path: "orders/create",
              component: require("./views/orders/Create.vue").default,
              name: "orders.create",
            },
          ],
        },
        {
          path: "events/:id",
          component: () =>
            import(
              /* webpackChunkName: "event" */ "./views/events/Wrapper.vue"
            ),
          children: [
            {
              path: "",
              redirect: { name: "events.dashboard" },
            },
            {
              path: "dashboard",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/Dashboard.vue"
                ),
              name: "events.dashboard",
            },
            {
              path: "orders",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/Orders.vue"
                ),
              name: "events.orders",
            },
            {
              path: "details",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/Details.vue"
                ),
              name: "events.details",
            },
            {
              path: "ticket-design",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/TicketDesign.vue"
                ),
              name: "events.ticketDesign",
            },
            {
              path: "finance",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/Finance.vue"
                ),
              name: "events.finance",
            },
            {
              path: "seats",
              component: () =>
                import(
                  /* webpackChunkName: "event" */ "./views/events/Seats.vue"
                ),
              name: "events.seats",
            },
          ],
        },
        {
          path: "orders/:id",
          component: () =>
            import(/* webpackChunkName: "order" */ "./views/Wrapper.vue"),
          children: [
            {
              path: "",
              component: () =>
                import(
                  /* webpackChunkName: "order" */ "./views/orders/Order.vue"
                ),
              name: "orders.order",
            },
          ],
        },
        {
          path: "account",
          component: () =>
            import(
              /* webpackChunkName: "account" */ "./views/account/Wrapper.vue"
            ),
          children: [
            {
              path: "",
              redirect: { name: "account.details" },
              name: "account",
            },
            {
              path: "details",
              name: "account.details",
              component: () =>
                import(
                  /* webpackChunkName: "account" */ "./views/account/Details.vue"
                ),
            },
          ],
        },
        {
          path: "settlement",
          component: () =>
            import(
              /* webpackChunkName: "account" */ "./views/settlement/Wrapper.vue"
            ),
          children: [
            {
              path: "",
              redirect: { name: "settlement.settlements" },
              name: "settlement",
            },
            {
              path: "settlements",
              name: "settlement.settlements",
              component: () =>
                import(
                  /* webpackChunkName: "settlement" */ "./views/settlement/Settlements.vue"
                ),
            },
            {
              path: "invoices",
              name: "settlement.invoices",
              component: () =>
                import(
                  /* webpackChunkName: "settlement" */ "./views/settlement/Invoices.vue"
                ),
            },
          ],
        },
      ],
    },

    {
      path: "/*",
      name: "404",
      component: require("./views/404.vue").default,
    },
  ],
});

export default router;
